import type { App } from 'vue';
import {
  Modal,
  Table,
  Menu,
  Input,
  Form,
  Card,
  Checkbox,
  Radio,
  Col,
  Row,
  Steps,
  Select,
  DatePicker,
  Tabs,
  Button,
  Divider,
  Pagination,
  Switch,
  Popconfirm,
  Tooltip,
  Layout,
  Descriptions,
  Breadcrumb,
  Dropdown,
  Avatar,
  Tag,
  Upload,
  Tree,
  Cascader,
  Timeline,
  Drawer,
  Empty,
  Progress,
  List,
  Image,
  Spin,
  Popover,
  Rate,
  Result,
  InputNumber,
  AutoComplete,
} from 'ant-design-vue';

import 'ant-design-vue/dist/antd.css';

export function setupAntd(app: App<Element>) {
  app
    .use(Form)
    .use(Input)
    .use(Modal)
    .use(Table)
    .use(Menu)
    .use(Card)
    .use(Checkbox)
    .use(Radio)
    .use(Col)
    .use(Row)
    .use(Select)
    .use(DatePicker)
    .use(Tabs)
    .use(Button)
    .use(Divider)
    .use(Pagination)
    .use(Switch)
    .use(Popconfirm)
    .use(Tooltip)
    .use(Layout)
    .use(Descriptions)
    .use(Breadcrumb)
    .use(Dropdown)
    .use(Avatar)
    .use(Tag)
    .use(Upload)
    .use(Tree)
    .use(Cascader)
    .use(Timeline)
    .use(Drawer)
    .use(Empty)
    .use(Progress)
    .use(List)
    .use(Image)
    .use(Popover)
    .use(Rate)
    .use(Result)
    .use(Spin)
    .use(Steps)
    .use(InputNumber).use(AutoComplete)
}
